import React from 'react';
import { connect } from 'react-redux';

import Loader from '../Loader';

import {
  grantEmrManagerRoleLoadingSelector,
  grantEmrManagerRoleErrorSelector,
} from '../../redux/selectors';

import { grantEmrManagerRoleToAdminStart } from '../../redux/actions';

const GrantEmrManagerRoleButton = ({ adminId, loading, error, grantEmrManagerRoleToAdminStart }) => {
  if (loading) return <Loader />;
  if (error) return "";

  return <a onClick={() => grantEmrManagerRoleToAdminStart({ adminId })}>Grant Emr Manager</a>
}

const mapStateToProps = (state, adminId) => ({
  loading: grantEmrManagerRoleLoadingSelector(state, adminId),
  error: grantEmrManagerRoleErrorSelector(state, adminId)
});

const mapDispatchToProps = {
  grantEmrManagerRoleToAdminStart
};

export default connect(mapStateToProps, mapDispatchToProps)(GrantEmrManagerRoleButton);
